import React from 'react';

// GLOBAL VARIABLES
import clsx from 'clsx';
import { INTERFACE, RECORD } from 'pathnames.js';

// FUNCTIONS/HELPERS
import { makePath } from 'functions.js';

// CORE COMPONENTS
import LinkCell from './LinkCell';

// MAIN COMPONENT
const TradeCell = ({ value: trades, placeholder }) => {
  return (
    <div>
      {trades?.length
        ? trades.map((trade, i) => (
            <div key={i} className={clsx(i !== 0 && 'mt-3')}>
              <div>
                {trade.vehicle || `${trade.vehicle_year} ${trade.make} ${trade.model}`}: {trade.acv}
              </div>
              <div>
                (
                <LinkCell
                  to={makePath(INTERFACE.inventory, RECORD.view, trade.daily_sales_inventory_id)}
                  placeholder={placeholder}
                >
                  {trade.stock_num}
                </LinkCell>
                )
              </div>
            </div>
          ))
        : placeholder}
    </div>
  );
};

// EXPORT
export default TradeCell;
